import { get as lodashGet } from 'lodash';
import { fromEvent } from 'rxjs';
import type { NodeEventHandler } from 'rxjs/internal/observable/fromEvent';

import { DebugKey } from '@swf/core/enums';
import { canUseDOM } from '@swf/core/utils';

import { createDebug } from '../utils/debug';

const debug = createDebug(DebugKey.Embedded);

export const get = (path: string | string[]) =>
  canUseDOM && lodashGet(window, ['starsweb', ...path]);

// TODO: refactor. First args element is selected: boolean.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const call = (path: string[], ...args: any) =>
  canUseDOM && lodashGet(window, ['starsweb', ...path], () => undefined)(...args);

export const attach = (name: string, handler: NodeEventHandler) =>
  fromEvent(document, name).subscribe((event) => {
    debug(name);
    handler(event);
  });
